import { createSlice } from "@reduxjs/toolkit";
import { InitialVendorFormData } from "../../ConstantData/InitialData";
const vendorSlice = createSlice({
  name: "vendor",
  initialState: {
    vendorList: [],
    dataEdit: {},
    errorData: {},
    billList: [],
    isError: false,
    initialData: InitialVendorFormData,
  },
  reducers: {
    getAllVendor: (state, action) => {
      state.vendorList = action.payload;
    },
    getVendorDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state, action) => {
      state.initialData = { ...InitialVendorFormData };
    },

    getVendor: () => {},
    createVendor: (state, actions) => {},
    updateVendor: () => {},
    deleteVendor: () => {},
  },
});
export const vendorSliceAction = vendorSlice.actions;
// deleteVendor

export default vendorSlice.reducer;
